import moment, { Moment } from 'moment'
import React from 'react'

import Select from '../../Select'
import { getMonthYearOptions } from '../constants'

type TMonthYearPicker = {
  date: Date
  onChange: (data: Moment) => void
}
const MonthYearPicker = (props: TMonthYearPicker): React.ReactElement => {
  const { date, onChange } = props

  const currentDate = moment(date)

  const onChangeMonthYear = (value: string): void => {
    const monthYear = moment(value)
    const newDate = moment(currentDate)
    newDate.month(monthYear.month())
    newDate.year(monthYear.year())
    const newMonth = moment(newDate)
    onChange(newMonth)
  }

  const value = moment.unix(0)

  value.month(currentDate.month())
  value.year(currentDate.year())

  const MONTH_YEAR_OPTIONS = getMonthYearOptions()

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
      }}
    >
      <div style={{ width: '25px' }} />
      <div style={{ flex: '1' }}>
        <Select
          options={MONTH_YEAR_OPTIONS}
          direct
          value={value.toISOString()}
          // slim
          onChange={onChangeMonthYear}
          // disabled
        />
      </div>
      <div style={{ width: '25px' }} />
    </div>
  )
}

export default MonthYearPicker
